var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-cascader',{staticStyle:{"width":"100%"},attrs:{"value":_vm.value,"options":_vm.REGIONDATA,"placeholder":_vm.placeholder,"clearable":""},on:{"input":_vm.updateValue}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }